document.addEventListener('DOMContentLoaded', function () {
	const initVideoLightboxButtons = () => {
		// Find all buttons with video lightbox enabled
		const videoLightboxButtons = document.querySelectorAll(
			'.wp-block-button--video-lightbox .wp-block-button__link'
		);

		if (videoLightboxButtons.length === 0) {
			return;
		}

		videoLightboxButtons.forEach((button) => {
			// Skip if already initialized
			if (button.dataset.videoLightboxInit) {
				return;
			}

			button.dataset.videoLightboxInit = 'true';

			// Add click handler
			button.addEventListener('click', function (e) {
				e.preventDefault();

				const videoUrl = this.getAttribute('href');

				if (!videoUrl) {
					return;
				}

				openVideoLightbox(videoUrl);
			});
		});
	};

	// Video lightbox function that uses the existing lightbox styles
	const openVideoLightbox = (videoUrl) => {
		// Check if a lightbox already exists
		let videoLightbox = document.querySelector('.component-video-lightbox');

		if (!videoLightbox) {
			// Create the lightbox structure
			videoLightbox = document.createElement('div');
			videoLightbox.classList.add('bg-dark', 'component-video-lightbox');
			videoLightbox.setAttribute('role', 'dialog');
			videoLightbox.setAttribute('aria-modal', 'true');

			const videoLightboxContainer = document.createElement('div');
			videoLightboxContainer.classList.add(
				'component-video-lightbox__container'
			);

			const videoLightboxContent = document.createElement('div');
			videoLightboxContent.classList.add(
				'component-video-lightbox__content'
			);

			const videoLightboxCloseOverlay = document.createElement('button');
			videoLightboxCloseOverlay.classList.add(
				'component-video-lightbox__close-button-overlay'
			);
			videoLightboxCloseOverlay.setAttribute('role', 'button');
			videoLightboxCloseOverlay.setAttribute(
				'aria-label',
				'Close Lightbox'
			);

			const videoLightboxCloseButton = document.createElement('span');
			videoLightboxCloseButton.classList.add(
				'component-video-lightbox__close-button'
			);

			// Add close functionality
			const closeLightbox = () => {
				videoLightbox.classList.remove('visible');
				setTimeout(() => {
					videoLightbox.classList.remove('active');
					// Clear the content
					videoLightboxContent.innerHTML = '';
				}, 400);
				document.removeEventListener('keydown', handleEscape);
			};

			// Add escape key handler
			const handleEscape = (e) => {
				if (e.key === 'Escape') {
					closeLightbox();
				}
			};

			videoLightboxCloseOverlay.addEventListener('click', closeLightbox);
			videoLightboxCloseButton.addEventListener('click', closeLightbox);

			// Store handlers for later use
			videoLightbox._closeLightbox = closeLightbox;
			videoLightbox._handleEscape = handleEscape;

			// Assemble the lightbox
			videoLightboxCloseOverlay.appendChild(videoLightboxCloseButton);
			videoLightboxContainer.appendChild(videoLightboxContent);
			videoLightbox.appendChild(videoLightboxContainer);
			videoLightbox.appendChild(videoLightboxCloseOverlay);
			document.body.appendChild(videoLightbox);
		}

		// Get the content container
		const videoLightboxContent = videoLightbox.querySelector(
			'.component-video-lightbox__content'
		);

		// Create the video wrapper structure
		const videoWrapper = document.createElement('div');
		videoWrapper.classList.add('component-video-lightbox__video');

		const innerWrapper = document.createElement('div');

		// Create an iframe for the video
		const iframe = document.createElement('iframe');
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute(
			'allow',
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
		);
		iframe.setAttribute('width', '100%');
		iframe.setAttribute('height', '100%');

		// Convert video URL to embed URL
		let embedUrl = videoUrl;

		// YouTube formats
		if (videoUrl.includes('youtube.com/watch')) {
			const videoId = videoUrl.split('v=')[1]?.split('&')[0];
			if (videoId) {
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			}
		} else if (videoUrl.includes('youtu.be/')) {
			const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
			if (videoId) {
				embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			}
		}
		// Vimeo format
		else if (videoUrl.includes('vimeo.com/')) {
			const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
			if (videoId) {
				embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
			}
		}
		// Wistia format
		else if (
			videoUrl.includes('wistia.com/') ||
			videoUrl.includes('wistia.net/')
		) {
			const matches = videoUrl.match(/medias\/([a-zA-Z0-9]+)/);
			if (matches && matches[1]) {
				embedUrl = `https://fast.wistia.net/embed/iframe/${matches[1]}?autoPlay=true`;
			}
		}

		iframe.src = embedUrl;

		// Build the nested structure
		innerWrapper.appendChild(iframe);
		videoWrapper.appendChild(innerWrapper);
		videoLightboxContent.innerHTML = '';
		videoLightboxContent.appendChild(videoWrapper);

		// Add escape key listener
		document.addEventListener('keydown', videoLightbox._handleEscape);

		// Show the lightbox
		videoLightbox.classList.add('active');
		setTimeout(() => {
			videoLightbox.classList.add('visible');
		}, 10);
	};

	// Initialize on page load
	initVideoLightboxButtons();

	// Re-initialize when AJAX content is loaded
	window.addEventListener(
		'propel-filters-render-posts',
		initVideoLightboxButtons
	);
});
